module.exports = __webpack_public_path__ + "img/itx-file-type-general.f288acb5.svg";